"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useActivateFreespins = void 0;
var keys_1 = require("../keys");
var useMutation_1 = require("../useMutation");
var react_1 = require("react");
var useActivateFreespins = function (_a) {
    var _b = _a === void 0 ? {} : _a, successAction = _b.successAction;
    var _c = (0, useMutation_1.useMutation)({
        successAction: successAction,
        keysUpdate: [keys_1.MY_FREESPINS, keys_1.BALANCE],
        path: keys_1.ACTIVATE_FREESPINS_BONUS,
    }), mutate = _c.mutate, isSubmitting = _c.isSubmitting, error = _c.error;
    return (0, react_1.useMemo)(function () { return ({
        activateFreespins: mutate,
        isSubmitting: isSubmitting,
        error: error,
    }); }, [mutate, isSubmitting, error]);
};
exports.useActivateFreespins = useActivateFreespins;
